import { SpinnerContainer, Spinner } from './styles'

export const Loading = (prop) => {
  return (
    <SpinnerContainer>
      <Spinner size={prop.size} />
    </SpinnerContainer>
  )
}
